/* HobbyChef — košíkový panel (drawer). Vyjede po přidání do košíku.

   Obsah panelu vykresluje Liquid (sections/hc-cart-drawer.liquid), tenhle
   skript jen volá cart AJAX a vymění vnitřek panelu za HTML, které Shopify
   vrátí ze Section Rendering API. Žádné skládání HTML v prohlížeči — sazba
   zůstává na jednom místě.

   Nůž a jeho doplňky (pouzdro, gravírování) jsou v košíku samostatné
   řádky. Drží je pohromadě skrytá vlastnost `_hc_nuz` se stejnou hodnotou
   na noži i na jeho doplňcích (podtržítko = pokladna ji zákazníkovi
   neukáže). Pravidlo množství: pouzdro i gravírování mají vždy tolik kusů
   jako jejich nůž — jedno pouzdro a jedno gravírování na každou
   čepel. Hlídá to setQty (mění nůž i doplňky naráz) a reconcile (srovná
   rozjeté množství po každém překreslení, třeba po úpravě na /cart).

   Pouzdro je od 23. 9. 2026 placené a párované podle nože (viz
   snippets/hc-pouzdro.liquid), dřív to byl dárek zdarma. Košíky z té doby
   nesou na položce pouzdra „Dárek k nákupu“ a na noži `_Pouzdro zdarma`;
   panel je pořád pozná, nové přidává pod dnešními názvy.

   Doplňky jsou u nože SKRYTÉ (od 10. 9. 2026 večer): `_Pouzdro`,
   `_Gravírování — text`, `_Gravírování — písmo`. Viditelně je nesou jen
   položky pouzdra („Pouzdro k noži“) a gravírování (text, písmo), takže
   se v pokladně u nože neopakují. Vlastnosti s podtržítkem Shopify
   zákazníkovi v pokladně neukáže, v administraci u objednávky ano
   (shopify.dev, Cart API → Private properties and attributes). Košík
   ze starší doby nese u nože viditelné názvy — čtou se taky a při první
   změně v panelu se převedou.

   Bez JS se nic nerozbije: formulář na produktovce odešle klasicky a
   zákazník skončí na /cart. */
(function () {
  'use strict';

  var SECTION = 'hc-cart-drawer';
  var TOKEN = '_hc_nuz';
  /* Viditelná vlastnost položky pouzdra — tatáž, jakou posílá produktovka
     (data-hc-item-props v sections/hc-product-main.liquid), ať je objednávka
     z panelu a z produktovky k nerozeznání. */
  var CASE_PROP = 'Pouzdro k noži';
  /* Viditelná vlastnost houbičky zdarma k prkénku Hasegawa (30. 9. 2026),
     tatáž jako v data-hc-item-props na produktovce. Je to skrytý dárkový
     produkt za 0 Kč; panel jen hlídá, aby houbiček bylo tolik jako prkének,
     a bez prkénka žádná (snippets/hc-houbicka.liquid). */
  var GIFT_PROP = 'Dárek k prkénku';
  /* Dárek zdarma ke dvěma nožům (12. 10. 2026, CLAUDE.md §40): skrytý
     balíček za 0 Kč (kámen nebo ostřič), jeden na objednávku od dvou kusů
     nožů z řad v akci (od 14. 10. 2026, §43). Panel ho pozná podle štítku
     (druh řádku `darek-noze`), vlastnost je pro pokladnu a pixel. Výběr
     dárku viz pickGift, hlídání setQty a reconcile. */
  var GIFT2_PROP = 'Dárek ke 2 nožům';
  var GIFT2_MIN = 2;
  /* Skrytá vlastnost placeného ostřiče z akce „2 nože + ostřič zdarma“
     (od 19. 10. 2026). Panel podle ní řádek pozná jako dárek ke dvěma nožům. */
  var AKCE_PROP = '_akce';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function root() { return document.querySelector('[data-hc-cd]'); }
  function contents() { return document.querySelector('[data-hc-cd-contents]'); }

  /* ---- otevření / zavření ------------------------------------------------ */

  var lastFocus = null;

  function open() {
    var el = root();
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    /* Reflow, aby CSS transition zabrala i při prvním otevření. */
    void el.offsetWidth;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    var close = el.querySelector('[data-hc-cd-close-btn]');
    if (close) close.focus();
  }

  function close() {
    var el = root();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    /* Skrýt až po dojetí animace, ať panel nezmizí skokem. */
    window.setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { close(); return; }
    if (e.key !== 'Tab') return;
    /* Držet fokus uvnitř panelu. */
    var el = root();
    if (!el) return;
    var f = el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---- komunikace s košíkem --------------------------------------------- */

  function busy(on) {
    var el = root();
    if (el) el.classList.toggle('is-busy', !!on);
  }

  /* Přidání do košíku. S nahraným souborem (logo pro gravírování) jde
     jako multipart: Shopify soubor uloží a do vlastnosti dá odkaz na něj.
     Bez souboru beze změny přes JSON. */
  function postAdd(body) {
    var hasFiles = body.items.some(function (x) { return x._files; });
    if (!hasFiles) return post('/cart/add.js', body);
    var fd = new FormData();
    body.items.forEach(function (x, i) {
      var p = 'items[' + i + ']';
      fd.append(p + '[id]', x.id);
      fd.append(p + '[quantity]', x.quantity || 1);
      Object.keys(x.properties || {}).forEach(function (k) { fd.append(p + '[properties][' + k + ']', x.properties[k]); });
      Object.keys(x._files || {}).forEach(function (k) { fd.append(p + '[properties][' + k + ']', x._files[k], x._files[k].name); });
    });
    if (body.sections) fd.append('sections', [].concat(body.sections).join(','));
    if (body.sections_url) fd.append('sections_url', body.sections_url);
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw Object.assign(new Error(data.description || data.message || 'Chyba košíku'), { data: data });
        return data;
      });
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw Object.assign(new Error(data.description || data.message || 'Chyba košíku'), { data: data });
        return data;
      });
    });
  }

  function withSections(body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return body;
  }

  /* Panel se překresluje ze serveru. Když volání vrátí `sections` rovnou
     (add.js/change.js/update.js to umí), použije se to; jinak se dotáhne. */
  function sectionHtml(data) {
    if (data && data.sections && data.sections[SECTION]) return Promise.resolve(data.sections[SECTION]);
    return fetch(window.location.pathname + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j[SECTION]; });
  }

  /* Rozepsaný konfigurátor server nezná, takže by ho překreslení smazalo —
     přenáší se. `bez` = nůž (nebo true = všechny), jehož koncept se
     nepřenáší, protože se právě uložil a má vyhrát stav ze serveru. */
  function swap(html, bez) {
    if (!html) return;
    var box = contents();
    if (!box) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-hc-cd-contents]');
    if (fresh) {
      var koncepty = takeDrafts(box, bez);
      box.innerHTML = fresh.innerHTML;
      if (window.hcEngrave) window.hcEngrave.init(box);
      putDrafts(box, koncepty);
      /* Až doběhne akce, která překreslila (ta ještě vypíná busy). */
      window.setTimeout(reconcile, 0);
    }
    syncCount(doc);
  }

  /* Počet kusů u ikony košíku v hlavičce. Sekce ho nese v data atributu,
     ať se nemusí překreslovat celá hlavička. */
  function syncCount(doc) {
    var src = (doc || document).querySelector('[data-hc-cd-count]');
    if (!src) return;
    var n = parseInt(src.getAttribute('data-hc-cd-count'), 10);
    if (isNaN(n)) return;
    var badge = document.querySelector('.hc-cart__count');
    var link = document.querySelector('.hc-cart');
    if (n > 0) {
      if (!badge && link) {
        badge = document.createElement('span');
        badge.className = 'hc-cart__count';
        link.appendChild(badge);
      }
      if (badge) badge.textContent = n;
    } else if (badge) {
      badge.remove();
    }
  }

  function banner(title) {
    var el = document.querySelector('[data-hc-cd-banner]');
    if (!el) return;
    if (!title) { el.hidden = true; return; }
    var tpl = el.getAttribute('data-hc-cd-banner') || '%produkt%';
    var slot = el.querySelector('[data-hc-cd-banner-text]');
    if (slot) slot.textContent = tpl.replace('%produkt%', title);
    el.hidden = false;
  }

  function fail(msg) {
    var el = document.querySelector('[data-hc-cd-error]');
    if (!el) { window.alert(msg); return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function errText(err) { return (err && err.data && err.data.description) || (err && err.message) || 'Chyba košíku'; }

  /* ---- datová vrstva ------------------------------------------------------
     assets/hobbychef-datalayer.js (window.hcDL). Akce zákazníka si vezme
     stav košíku z panelu PŘED zápisem (dlSnap) a hned po překreslení panelu
     z něj hcDL spočítá add_to_cart / remove_from_cart (dlDiff). reconcile()
     je zápis systému, stav nebere, takže se nehlásí — běží až přes
     setTimeout po swap(), mimo rozdíl akce. Chyba měření nesmí rozbít
     košík, proto všechno v try/catch.
     Panel zápisy neřadí za sebe (fronta +/− běží i během jiné akce),
     a tak si akce spočítá i `want` = co sama zapisuje, { klíč: ±kusů },
     klíč = varianta, u doplňku k noži „varianta|addon“ (viz dlAdd).
     Rozdíl se hlásí jen v těchhle mezích — jinak by souběžná akce nebo
     reconcile() prosákly do jejího add_to_cart / remove_from_cart. */
  function dlSnap() {
    try { return window.hcDL ? window.hcDL.cart() : null; } catch (e) { return null; }
  }

  function dlDiff(pred, want) {
    if (!pred || !window.hcDL) return;
    try { window.hcDL.cartDiff(pred, window.hcDL.cart(), want); } catch (e) { /* měření mimo */ }
  }

  function dlCall(name) {
    if (!window.hcDL) return;
    try { window.hcDL[name](); } catch (e) { /* měření mimo */ }
  }

  /* Varianta o `n` kusů víc (add.js), záporně míň. Doplněk k noži (pouzdro,
     gravírování) jde pod klíčem „varianta|addon“ (24. 9. 2026): totéž
     pouzdro může být v košíku i samostatně a cartDiff podle klíče pozná,
     který řádek akce zapsala (item_type). */
  function dlAdd(want, variant, n, addon) {
    var k = variant ? String(variant) + (addon ? '|addon' : '') : '';
    if (k && n) want[k] = (want[k] || 0) + n;
    return want;
  }

  /* Řádek `key` na `q` kusů (update.js, change.js) — o kolik proti stavu
     před akcí. Řádek, který v něm není, se nehlásí. */
  function dlSet(want, pred, key, q) {
    var hit = ((pred && pred.items) || []).filter(function (l) { return l && String(l.key) === String(key); })[0];
    if (hit) dlAdd(want, String(hit.variant_id), (parseInt(q, 10) || 0) - (parseInt(hit.quantity, 10) || 0), hit.addon === true);
    return want;
  }

  /* Po chybě uprostřed (služba přidaná, nůž ne) ukázat skutečný stav
     košíku, ne ten předpokládaný. `pred` = stav před akcí pro datovou
     vrstvu — rozdíl pak ukáže, co se opravdu stalo. */
  function failAndRefresh(err, pred, want) {
    return sectionHtml(null)
      .then(function (html) { swap(html); dlDiff(pred, want); })
      .catch(function () {})
      .then(function () { fail(errText(err)); return false; });
  }

  /* Kroky po sobě — Cloudflare nemá rád dávky souběžných zápisů. Poslední
     krok vrací panel ze Section Rendering API. `pred` a `want` (nepovinné)
     = stav košíku před akcí zákazníka a co akce zapisuje, viz dlSnap. */
  function run(steps, last, bez, pred, want) {
    busy(true);
    var p = Promise.resolve();
    steps.forEach(function (s) { if (s) p = p.then(s); });
    return p.then(last)
      .then(sectionHtml)
      .then(function (html) { swap(html, bez); dlDiff(pred, want); return true; })
      .catch(function (err) { return failAndRefresh(err, pred, want); })
      .then(function (ok) { busy(false); return ok; });
  }

  function newToken() {
    return Date.now().toString(36).slice(-6) + Math.random().toString(36).slice(2, 6);
  }

  /* ---- produktovka ------------------------------------------------------- */

  /* Vlastnosti bez spojky a prázdných hodnot — podle nich se pozná, že je
     v košíku tentýž nůž se stejnými doplňky. */
  function visible(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k !== TOKEN && props[k] !== '' && props[k] != null) out[k] = String(props[k]);
    });
    return out;
  }

  function sameProps(a, b) {
    var x = visible(a), y = visible(b), kx = Object.keys(x);
    return kx.length === Object.keys(y).length && kx.every(function (k) { return x[k] === y[k]; });
  }

  /* Spojka pro nový nákup: je-li v košíku tentýž nůž se stejnými doplňky,
     převezme jeho — Shopify pak sloučí nůž i doplňky do stávajících řádků
     a množství zůstanou v páru. Jinak nová, takže nůž s jiným gravírováním
     je vlastní řádek s vlastními doplňky. */
  function tokenFor(item) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hit = (cart.items || []).filter(function (l) {
          return String(l.variant_id) === String(item.id) && l.properties && l.properties[TOKEN] &&
            sameProps(l.properties, item.properties);
        })[0];
        return hit ? hit.properties[TOKEN] : newToken();
      })
      .catch(function () { return newToken(); });
  }

  /* Vlastnosti nože přejmenovat na skryté: pole s data-hc-knife-prop se
     u nože zapíše pod tímhle klíčem, prázdná hodnota = u nože vůbec
     (zaškrtávátko gravírování — text stačí). form.elements bere i pole
     svázaná přes form="". */
  function knifeKeys(form, props) {
    var map = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.name.indexOf('properties[') !== 0 || !el.hasAttribute('data-hc-knife-prop')) return;
      map[el.name.slice(11, -1)] = el.getAttribute('data-hc-knife-prop');
    });
    var out = {};
    Object.keys(props).forEach(function (k) {
      if (!Object.prototype.hasOwnProperty.call(map, k)) out[k] = props[k];
      else if (map[k]) out[map[k]] = props[k];
    });
    return out;
  }

  function addFromForm(form) {
    var fd = new FormData(form);          /* vezme i checkboxy svázané přes form="" */
    var item = { quantity: 1 };
    fd.forEach(function (v, k) {
      if (k === 'id') item.id = v;
      else if (k === 'quantity') item.quantity = parseInt(v, 10) || 1;
      else if (k.indexOf('properties[') === 0) {
        item.properties = item.properties || {};
        item.properties[k.slice(11, -1)] = v;
      }
    });
    if (!item.id) return Promise.reject(new Error('Formulář nemá variantu'));
    if (item.properties) {
      item.properties = knifeKeys(form, item.properties);
      if (!Object.keys(item.properties).length) delete item.properties;
    }

    var extras = extraItems(form);

    busy(true);
    return (extras.length ? tokenFor(item) : Promise.resolve(''))
      .then(function (token) {
        if (token) {
          item.properties = item.properties || {};
          item.properties[TOKEN] = token;
          /* Pouzdro i gravírování na každý kus nože. */
          extras.forEach(function (x) {
            x.quantity = item.quantity;
            x.properties = x.properties || {};
            x.properties[TOKEN] = token;
          });
        }
        return postAdd(withSections({ items: [item].concat(extras) }));
      })
      .then(function (data) {
        var added = (data.items && data.items[0]) || data;
        return sectionHtml(data).then(function (html) {
          swap(html);
          /* add_to_cart: nůž + pouzdro + gravírování, poslané kusy. Proti
             prázdnému košíku, ne proti panelu před přidáním: ten může být
             starší než košík (stránka vrácená tlačítkem Zpět, jiná záložka)
             a přidání by se ztratilo. add.js prošlo, takže košík poslané
             kusy má; údaje položek jsou z čerstvého panelu. */
          var want = dlAdd({}, String(item.id), item.quantity || 1);
          /* Doplňky z produktovky: pouzdro, gravírování a houbička k prkénku. */
          extras.forEach(function (x) { dlAdd(want, String(x.id), x.quantity || 1, true); });
          dlDiff({ items: [] }, want);
          banner(added && (added.product_title || added.title));
          open();
        });
      })
      .catch(function (err) { fail(errText(err)); })
      .then(function () { busy(false); return autoGift(); });
  }

  /* Doplňky z produktovky (pouzdro, gravírování, od 30. 9. 2026 i houbička
     zdarma k prkénku) jdou do košíku jako vlastní položky, ne jen jako
     vlastnost nože — jinak by nebyly vidět v objednávce a u gravírování by
     se nepřipočetla cena. Variantu nese `data-hc-item`
     na zaškrtávátku; když ho nemá (varianta není v nastavení sekce), zůstane
     jen vlastnost u nože jako dřív. Množství a spojku doplní addFromForm. */
  function extraItems(form) {
    var out = [];
    document.querySelectorAll('[data-hc-item]').forEach(function (el) {
      if (el.form !== form) return;
      /* Vypnuté = k vybrané variantě se nenabízí (poklička k nádobí). */
      if (el.disabled) return;
      if (el.type === 'checkbox' && !el.checked) return;

      var item = { id: String(el.getAttribute('data-hc-item')), quantity: 1 };
      var props = {};
      var raw = el.getAttribute('data-hc-item-props');
      if (raw) { try { props = JSON.parse(raw) || {}; } catch (e) { props = {}; } }

      /* Gravírování si nese text a písmo i na vlastní položce, aby dílna
         nemusela dohledávat, ke kterému noži patří. */
      var panel = document.getElementById(el.getAttribute('aria-controls') || '');
      if (panel) {
        panel.querySelectorAll('input[name^="properties["]').forEach(function (f) {
          if (f.disabled) return;
          /* Soubor (logo z návrháře) jde s položkou jako příloha, ne jako text. */
          if (f.type === 'file') {
            if (f.files && f.files[0]) (item._files = item._files || {})[f.name.slice(11, -1)] = f.files[0];
            return;
          }
          if (f.type === 'radio' && !f.checked) return;
          if (!f.value) return;
          props[f.name.slice(11, -1)] = f.value;
        });
      }

      if (Object.keys(props).length) item.properties = props;
      out.push(item);
    });
    return out;
  }

  /* ---- řádky panelu ------------------------------------------------------ */

  function lineList() {
    var box = contents();
    return box ? Array.prototype.slice.call(box.querySelectorAll('[data-hc-cd-line]')) : [];
  }
  function lineByKey(key) { return lineList().filter(function (l) { return keyOf(l) === key; })[0] || null; }
  function keyOf(line) { return String(line.getAttribute('data-hc-cd-key')); }
  function qtyOf(line) { return parseInt(line.getAttribute('data-hc-cd-qty'), 10) || 1; }
  function kindOf(line) { return line.getAttribute('data-hc-cd-kind') || ''; }
  /* Zboží, ke kterému může patřit dárek: nůž i obyčejné zboží (prkénko),
     ne doplněk ani služba. */
  function isOwner(line) { var k = kindOf(line); return k === '' || k === 'knife'; }
  function tokenOf(line) { return line.getAttribute('data-hc-cd-token') || ''; }
  /* Množství i s nulou (qtyOf z prázdna dělá 1): stepper ho zapisuje do
     DOM dřív, než odejde na server. */
  function qtyNow(line) { var n = parseInt(line.getAttribute('data-hc-cd-qty'), 10); return isNaN(n) ? 1 : n; }

  /* Nůž, který se počítá do dárku ke dvěma nožům: jen z řad v akci
     (data-hc-cd-darek2 z Liquidu, snippets/hc-darek-noze-rada.liquid, §43).
     Od 26. 10. 2026 i sada z řady v akci, druh '' (zboží), každá jako
     jeden kus (§49). Atribut sází Liquid jen nožům a těm sadám. */
  function isGiftKnife(line) {
    var k = kindOf(line);
    return (k === 'knife' || k === '') && line.getAttribute('data-hc-cd-darek2') === '1';
  }

  /* Kusy nožů v akci v panelu; `line` a `q` = řádek, který se právě mění. */
  function knifeCount(line, q) {
    return lineList().reduce(function (sum, l) {
      return isGiftKnife(l) ? sum + (l === line ? q : qtyNow(l)) : sum;
    }, 0);
  }

  function giftLines() { return lineList().filter(function (l) { return kindOf(l) === 'darek-noze'; }); }

  /* Spojku dostane nůž při první změně doplňků v panelu (zboží přidané
     odjinud ji nemá). Zapisuje se hned do DOM, aby se podle ní našel
     i koncept po překreslení. */
  function ensureToken(knife) {
    var t = tokenOf(knife) || newToken();
    knife.setAttribute('data-hc-cd-token', t);
    return t;
  }

  /* Doplňky nože: řádky daného druhu se stejnou spojkou. */
  function paired(knife, kind) {
    var t = tokenOf(knife);
    if (!t) return [];
    return lineList().filter(function (l) { return l !== knife && kindOf(l) === kind && tokenOf(l) === t; });
  }

  /* Vlastnosti řádku tak, jak je vykreslil server. */
  function rawProps(line) {
    var raw = line.getAttribute('data-hc-cd-props');
    var props = {};
    if (raw) { try { props = JSON.parse(raw) || {}; } catch (e) { props = {}; } }
    return props;
  }

  /* Vlastnosti položky se přes change.js nahrazují celé, ne slučují —
     posílá se proto vždy kompletní sada z aktuálního stavu panelu.
     Zaškrtávátko gravírování se nebere: zaškrtnuté ještě neznamená
     uložené (viz saveEngrave), o jeho vlastnostech rozhoduje server. */
  function propsOf(line) {
    var props = rawProps(line);
    line.querySelectorAll('[data-hc-cd-addon]').forEach(function (input) {
      if (input.hasAttribute('data-hc-engrave-toggle')) return;
      var name = input.getAttribute('data-hc-cd-addon');
      /* Starý viditelný název (košík před skrytými vlastnostmi) pryč —
         doplněk dál drží skrytý klíč. */
      var legacy = input.getAttribute('data-hc-cd-legacy');
      if (legacy && legacy !== name) delete props[legacy];
      if (input.checked) props[name] = input.value || 'ano';
      else delete props[name];
    });
    return props;
  }

  function knifeChange(knife, props) {
    return function () {
      return post('/cart/change.js', withSections({ id: keyOf(knife), quantity: qtyOf(knife), properties: props }));
    };
  }

  /* Vynulovat řádky jedním voláním. */
  function zero(lines) {
    if (!lines.length) return null;
    var updates = {};
    lines.forEach(function (l) { updates[keyOf(l)] = 0; });
    return function () { return post('/cart/update.js', { updates: updates }); };
  }

  /* ---- množství --------------------------------------------------------- */

  /* Nůž mění množství i svým doplňkům — jedním update.js, ať se nikdy
     nerozjedou. Doplňky samy stepper nemají (zamčený v Liquidu). */
  function setQty(key, q) {
    var line = lineByKey(key);
    var updates = {};
    updates[key] = q;
    if (line && kindOf(line) === 'knife') {
      paired(line, 'pouzdro').concat(paired(line, 'engrave')).forEach(function (l) { updates[keyOf(l)] = q; });
    }
    /* Houbička zdarma jde s prkénkem, a to nožem není. */
    if (line && isOwner(line)) {
      paired(line, 'darek').forEach(function (l) { updates[keyOf(l)] = q; });
    }
    /* Pod dva nože v akci dárek ke dvěma nožům pryč, týmž zápisem. */
    if (line && isGiftKnife(line) && knifeCount(line, q) < GIFT2_MIN) {
      giftLines().forEach(function (l) { updates[keyOf(l)] = 0; });
    }
    var giftKnife = !!(line && isGiftKnife(line));
    var pred = dlSnap();
    var want = {};
    Object.keys(updates).forEach(function (k) { dlSet(want, pred, k, updates[k]); });
    return run([], function () { return post('/cart/update.js', withSections({ updates: updates })); }, undefined, pred, want)
      /* Druhý nůž v akci přidaný „+“: ostřič zaškrtnutý předem (autoGift). */
      .then(function (ok) { return ok && giftKnife ? autoGift().then(function () { return ok; }) : ok; });
  }

  /* Klikání na +/− se slučuje: Cloudflare sestřelí ~6 rychlých zápisů za
     sebou, a překreslovat panel po každém kliknutí je stejně zbytečné. */
  var pending = {};
  var timer = null;

  function queueQty(key, qty) {
    pending[key] = qty;
    var line = lineByKey(key);
    if (line) {
      line.setAttribute('data-hc-cd-qty', qty);
      var num = line.querySelector('.hc-cd__qty-num');
      if (num) num.textContent = qty;
    }
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      var next = Object.keys(pending)[0];
      if (!next) return;
      var q = pending[next];
      delete pending[next];
      setQty(next, q).then(function () {
        var dalsi = Object.keys(pending)[0];
        if (dalsi) queueQty(dalsi, pending[dalsi]);
      });
    }, 350);
  }

  /* Srovnat doplňky s noži: pouzdro a gravírování mají tolik kusů jako
     jejich nůž, bez nože (nebo s odškrtnutým doplňkem) žádný, a chybějící
     se doplní. Týká se jen řádků se spojkou — starší košík bez ní se
     nechává, jak je. Každý nesoulad se zkouší jednou: kdyby ho obchod
     nepřijal (třeba vyprodané pouzdro), panel se nezacyklí. */
  var lastFix = '';

  function addonItem(knife, kind) {
    var t = tokenOf(knife);
    var props = {};
    if (kind === 'pouzdro') {
      var pv = knife.getAttribute('data-hc-cd-pouzdro-variant') || '';
      if (!pv) return null;
      props[CASE_PROP] = knife.getAttribute('data-hc-cd-title') || '';
      props[TOKEN] = t;
      return { id: pv, quantity: qtyOf(knife), properties: props };
    }
    /* Houbička k prkénku nebo poklička k nádobí (od 17. 10. 2026): „knife“
       je tady prkénko či pánev, variantu dárku i název vlastnosti nese
       jeho řádek. */
    if (kind === 'darek') {
      var dv = knife.getAttribute('data-hc-cd-darek-variant') || '';
      if (!dv) return null;
      props[knife.getAttribute('data-hc-cd-darek-prop') || GIFT_PROP] = knife.getAttribute('data-hc-cd-darek-of') || '';
      props[TOKEN] = t;
      return { id: dv, quantity: qtyOf(knife), properties: props };
    }
    var g = engraveOf(knife.querySelector('[data-hc-cd-engrave-form]'));
    if (!g || !g.variant || !g.saved || !g.saved.text) return null;
    props[g.textProp] = g.saved.text;
    if (g.saved.font) props[g.fontProp] = g.saved.font;
    props[TOKEN] = t;
    return { id: g.variant, quantity: qtyOf(knife), properties: props };
  }

  function reconcile() {
    var all = lineList();
    var knives = {};
    /* Vlastník houbičky zdarma je prkénko — obyčejné zboží, ne nůž. */
    var owners = {};
    all.forEach(function (l) {
      var t = tokenOf(l);
      if (!t) return;
      if (kindOf(l) === 'knife') knives[t] = l;
      if (isOwner(l)) owners[t] = l;
    });

    var updates = {};
    var adds = [];
    var seen = {};
    all.forEach(function (l) {
      var k = kindOf(l), t = tokenOf(l);
      if ((k !== 'pouzdro' && k !== 'engrave' && k !== 'darek') || !t) return;
      var owner = k === 'darek' ? owners[t] : knives[t];
      var want = owner && !seen[k + t] && owner.getAttribute('data-hc-cd-want-' + k) === '1' ? qtyOf(owner) : 0;
      seen[k + t] = true;
      if (qtyOf(l) !== want) updates[keyOf(l)] = want;
    });
    Object.keys(knives).forEach(function (t) {
      ['pouzdro', 'engrave'].forEach(function (k) {
        if (seen[k + t] || knives[t].getAttribute('data-hc-cd-want-' + k) !== '1') return;
        var item = addonItem(knives[t], k);
        if (item) adds.push(item);
      });
    });
    Object.keys(owners).forEach(function (t) {
      if (seen['darek' + t] || owners[t].getAttribute('data-hc-cd-want-darek') !== '1') return;
      var item = addonItem(owners[t], 'darek');
      if (item) adds.push(item);
    });
    /* Dárek ke dvěma nožům: nejvýš jeden kus, a jen od dvou nožů v akci
       (třeba po úpravě na /cart). Chybějící se nedoplňuje, vybírá zákazník. */
    var knivesNow = knifeCount(null, 0);
    giftLines().forEach(function (l, i) {
      var want = knivesNow >= GIFT2_MIN && i === 0 ? 1 : 0;
      if (qtyNow(l) !== want) updates[keyOf(l)] = want;
    });

    if (!Object.keys(updates).length && !adds.length) return;
    var sig = JSON.stringify([updates, adds]);
    if (sig === lastFix) return;
    lastFix = sig;

    var steps = [];
    if (adds.length) steps.push(function () { return post('/cart/add.js', { items: adds }); });
    run(steps, function () { return post('/cart/update.js', withSections({ updates: updates })); });
  }

  /* ---- dárek ke dvěma nožům ----------------------------------------------
     Volba v nabídce pod položkami (radio) přidá vybraný balíček za 0 Kč
     a jiný dárek z košíku vyřadí. Nejdřív přidat, pak vyřadit: když
     přidání neprojde (vyprodáno), zůstane zákazníkovi dosavadní dárek. */

  function pickGift(input) {
    var v = String(input.getAttribute('data-hc-cd-gift-pick') || '');
    if (!v) return Promise.resolve(false);
    giftOptOut(false);
    var gifts = giftLines();
    var keep = gifts.filter(function (l) { return l.getAttribute('data-hc-cd-variant') === v; })[0] || null;
    var updates = {};
    gifts.forEach(function (l) { if (l !== keep) updates[keyOf(l)] = 0; });
    if (keep && qtyNow(keep) !== 1) updates[keyOf(keep)] = 1;
    var pred = dlSnap();
    var want = {};
    Object.keys(updates).forEach(function (k) { dlSet(want, pred, k, updates[k]); });
    var hasUpdates = Object.keys(updates).length > 0;
    var update = function () { return post('/cart/update.js', withSections({ updates: updates })); };
    if (keep) return hasUpdates ? run([], update, undefined, pred, want) : Promise.resolve(true);

    /* Ostřič (od 19. 10. 2026) není balíček za 0 Kč, ale placený produkt,
       který zlevní automatická sleva v adminu. Nese jen skrytou _akce —
       „Dárek ke 2 nožům: zdarma“ by v pokladně lhalo, když zákazník místo
       akce uplatní slevový kód a ostřič zaplatí (CLAUDE.md §46). */
    var props = {};
    var akce = input.getAttribute('data-hc-cd-gift-akce') || '';
    if (akce) props[AKCE_PROP] = akce;
    else props[GIFT2_PROP] = 'zdarma';
    dlAdd(want, v, 1, true);
    var add = function () { return post('/cart/add.js', withSections({ items: [{ id: v, quantity: 1, properties: props }] })); };
    if (!hasUpdates) return run([], add, undefined, pred, want);
    return run([function () { return post('/cart/add.js', { items: [{ id: v, quantity: 1, properties: props }] }); }], update, undefined, pred, want);
  }

  /* Ostřič zaškrtnutý předem (klient 19. 10. 2026: „aby tam defaultně byl
     zaškrtnutý ten ostřič zdarma“). Když jsou v košíku dva nože v akci a
     žádný dárek, přidá se ostřič sám. Volá se jen po akci zákazníka (přidání
     z produktovky, „+“ v panelu), ne z reconcile. Kdo zvolí „Bez dárku“, tomu
     se ostřič znovu nepřidává, dokud nožů neklesne pod dva: s kódem by ho
     jinak zaplatil, a dárek v panelu jinak odebrat nejde (CLAUDE.md §46). */
  var GIFT2_NE = 'hc_darek2_ne';

  function giftOptOut(on) {
    try {
      if (on === undefined) return window.sessionStorage.getItem(GIFT2_NE) === '1';
      if (on) window.sessionStorage.setItem(GIFT2_NE, '1');
      else window.sessionStorage.removeItem(GIFT2_NE);
    } catch (e) { /* bez úložiště se jen pamatovat nebude */ }
    return false;
  }

  function autoGift() {
    var n = knifeCount(null, 0);
    if (n < GIFT2_MIN) { giftOptOut(false); return Promise.resolve(false); }
    if (giftLines().length || giftOptOut()) return Promise.resolve(false);
    var box = contents();
    var input = box && box.querySelector('[data-hc-cd-gift-pick][data-hc-cd-gift-akce]');
    return input ? pickGift(input) : Promise.resolve(false);
  }

  /* „Bez dárku“: dárek z košíku pryč a zapamatovat si to. */
  function noGift() {
    giftOptOut(true);
    var gifts = giftLines();
    if (!gifts.length) return Promise.resolve(true);
    var updates = {};
    gifts.forEach(function (l) { updates[keyOf(l)] = 0; });
    var pred = dlSnap();
    var want = {};
    Object.keys(updates).forEach(function (k) { dlSet(want, pred, k, updates[k]); });
    return run([], function () { return post('/cart/update.js', withSections({ updates: updates })); }, undefined, pred, want);
  }

  /* ---- pouzdro k noži ----------------------------------------------------
     Zaškrtnutí přidá pouzdro jako vlastní placenou položku (tolik kusů jako
     nůž), odškrtnutí ji vynuluje. Kterou variantu, říká nůž v atributu
     data-hc-cd-pouzdro-variant — sází ho Liquid podle snippetu hc-pouzdro,
     takže se v panelu i na produktovce nabízí totéž pouzdro. */

  function togglePouzdro(knife, input) {
    var props = propsOf(knife);           /* doplněk podle zaškrtávátka */
    var token = ensureToken(knife);
    props[TOKEN] = token;
    var cases = paired(knife, 'pouzdro');
    var pv = knife.getAttribute('data-hc-cd-pouzdro-variant') || '';
    var steps = [];
    var pred = dlSnap();
    var want = dlSet({}, pred, keyOf(knife), qtyOf(knife));   /* knifeChange, obvykle beze změny */
    if (input.checked) {
      if (pv && !cases.length) {
        var cp = {};
        cp[CASE_PROP] = knife.getAttribute('data-hc-cd-title') || '';
        cp[TOKEN] = token;
        steps.push(function () {
          return post('/cart/add.js', { items: [{ id: pv, quantity: qtyOf(knife), properties: cp }] });
        });
        dlAdd(want, pv, qtyOf(knife), true);
      }
    } else {
      steps.push(zero(cases));
      cases.forEach(function (l) { dlSet(want, pred, keyOf(l), 0); });
    }
    return run(steps, knifeChange(knife, props), undefined, pred, want);
  }

  /* ---- gravírování v panelu ---------------------------------------------
     Zaškrtnutí jen rozbalí konfigurátor (tentýž jako na produktovce, viz
     snippets/hc-engrave.liquid a assets/hobbychef-engrave.js). Do košíku
     jde až tlačítkem Uložit — nůž s „+ Gravírování na čepel“ bez textu by
     dílna nevyrobila. Uloží se totéž co z produktovky:
       nůž     skrytě _Gravírování — text a _Gravírování — písmo + spojka
               (addFromForm přejmenuje pole formuláře, viz knifeKeys),
       služba  položka varianty gravírování s textem, písmem a spojkou,
               tolik kusů jako nůž (extraItems).
     Po uložení se konfigurátor sbalí do shrnutí s odkazem „Upravit
     gravírování“. Odškrtnutí uloženého obojí odebere. */

  function propName(input) {
    var n = input.getAttribute('name') || '';
    return n.indexOf('properties[') === 0 ? n.slice(11, -1) : n;
  }

  function engraveOf(form) {
    var line = form && form.closest('[data-hc-cd-line]');
    if (!line) return null;
    var toggle = line.querySelector('[data-hc-engrave-toggle]');
    var input = form.querySelector('[data-hc-engrave-input]');
    var panel = form.querySelector('[data-hc-engrave]');
    if (!toggle || !input || !panel) return null;
    var fonts = form.querySelectorAll('[data-hc-engrave-font]');
    var picked = form.querySelector('[data-hc-engrave-font]:checked');
    var label = toggle.getAttribute('data-hc-cd-addon');
    var textProp = propName(input);
    var fontProp = fonts.length ? propName(fonts[0]) : '';
    /* U nože skrytě (_Gravírování — text), u služby viditelně. */
    var knifeText = input.getAttribute('data-hc-knife-prop') || ('_' + textProp);
    var knifeFont = fonts.length ? (fonts[0].getAttribute('data-hc-knife-prop') || ('_' + fontProp)) : '';
    var props = rawProps(line);
    var saved = null;
    if (props[knifeText]) saved = { text: props[knifeText], font: props[knifeFont] || '' };
    /* Košík ze starší doby: příznak doplňku a viditelný text u nože. */
    else if (props[label]) saved = { text: props[textProp] || '', font: props[fontProp] || '' };
    return {
      form: form,
      line: line,
      toggle: toggle,
      input: input,
      panel: panel,
      sum: line.querySelector('[data-hc-cd-engrave-sum]'),
      collapsed: panel.hasAttribute('data-hc-engrave-sbaleno'),
      label: label,
      textProp: textProp,
      fontProp: fontProp,
      knifeText: knifeText,
      knifeFont: knifeFont,
      variant: form.getAttribute('data-hc-cd-engrave-variant') || '',
      text: input.value,
      font: picked ? picked.value : '',
      saved: saved
    };
  }

  /* Uloženo a beze změny. */
  function isClean(g) {
    return !!(g && g.saved && g.saved.text && g.text === g.saved.text && g.font === g.saved.font);
  }

  /* Rozbalené a neuložené (nebo upravené) — tohle drží jen prohlížeč. */
  function isDraft(g) {
    return !!(g && g.toggle.checked && !g.collapsed && !isClean(g));
  }

  function setCollapsed(g, sbalit, fokus) {
    if (sbalit) g.panel.setAttribute('data-hc-engrave-sbaleno', '');
    else g.panel.removeAttribute('data-hc-engrave-sbaleno');
    if (g.sum) g.sum.hidden = !sbalit;
    if (window.hcEngrave) window.hcEngrave.sync(g.toggle, !!fokus);
  }

  /* Služba z doby před spojkou (košík z 10. 9. 2026): páruje se textem. */
  function legacyService(g) {
    if (!g.variant || !g.saved) return null;
    return lineList().filter(function (l) {
      var p = rawProps(l);
      return l !== g.line && !tokenOf(l) && l.getAttribute('data-hc-cd-variant') === g.variant &&
        p[g.textProp] === g.saved.text;
    })[0] || null;
  }

  function saveEngrave(form) {
    var g = engraveOf(form);
    if (!g) return Promise.resolve(false);
    /* reportValidity vyvolá `invalid` — hobbychef-engrave.js ukáže českou
       hlášku pod polem, bublina prohlížeče se neukáže. */
    if (form.reportValidity && !form.reportValidity()) return Promise.resolve(false);
    /* Rozbalené uložené beze změny: jen sbalit. */
    if (isClean(g)) { setCollapsed(g, true); return Promise.resolve(true); }

    var token = ensureToken(g.line);
    var knife = propsOf(g.line);
    /* Staré viditelné názvy pryč, u nože jen skrytě. */
    delete knife[g.label];
    delete knife[g.textProp];
    delete knife[g.fontProp];
    knife[g.knifeText] = g.text;
    if (g.font) knife[g.knifeFont] = g.font;
    else delete knife[g.knifeFont];
    knife[TOKEN] = token;

    var sp = {};
    sp[g.textProp] = g.text;
    if (g.font) sp[g.fontProp] = g.font;
    sp[TOKEN] = token;
    var svc = paired(g.line, 'engrave')[0] || legacyService(g);

    /* Nejdřív služba: když neprojde (vyprodaná, smazaná varianta), nůž
       zůstane bez gravírování a nic se nerozejde. */
    var steps = [];
    var pred = dlSnap();
    var want = dlSet({}, pred, keyOf(g.line), qtyOf(g.line));
    if (g.variant) {
      steps.push(svc
        ? function () { return post('/cart/change.js', { id: keyOf(svc), quantity: qtyOf(g.line), properties: sp }); }
        : function () { return post('/cart/add.js', { items: [{ id: g.variant, quantity: qtyOf(g.line), properties: sp }] }); });
      if (svc) dlSet(want, pred, keyOf(svc), qtyOf(g.line));
      else dlAdd(want, g.variant, qtyOf(g.line), true);
    }
    return run(steps, knifeChange(g.line, knife), token, pred, want);
  }

  function removeEngrave(g) {
    var knife = propsOf(g.line);
    delete knife[g.label];
    delete knife[g.textProp];
    delete knife[g.fontProp];
    delete knife[g.knifeText];
    delete knife[g.knifeFont];
    var svc = paired(g.line, 'engrave');
    if (!svc.length) { var l = legacyService(g); if (l) svc = [l]; }
    var pred = dlSnap();
    var want = dlSet({}, pred, keyOf(g.line), qtyOf(g.line));
    svc.forEach(function (s) { dlSet(want, pred, keyOf(s), 0); });
    return run([zero(svc)], knifeChange(g.line, knife), tokenOf(g.line) || true, pred, want);
  }

  /* Koncepty se párují podle spojky nože, bez ní podle klíče řádku —
     klíč se mění se změnou vlastností, spojka ne. */
  function takeDrafts(box, bez) {
    var out = {};
    if (bez === true) return out;
    box.querySelectorAll('[data-hc-cd-engrave-form]').forEach(function (f) {
      var g = engraveOf(f);
      if (!g || !g.toggle.checked || g.collapsed) return;
      var id = tokenOf(g.line) || keyOf(g.line);
      if (id === bez) return;
      out[id] = { text: g.text, font: g.font };
    });
    return out;
  }

  function putDrafts(box, koncepty) {
    box.querySelectorAll('[data-hc-cd-engrave-form]').forEach(function (f) {
      var g = engraveOf(f);
      if (!g) return;
      var d = koncepty[tokenOf(g.line)] || koncepty[keyOf(g.line)];
      if (!d) return;
      g.toggle.checked = true;
      g.input.value = d.text;
      f.querySelectorAll('[data-hc-engrave-font]').forEach(function (r) { r.checked = r.value === d.font; });
      setCollapsed(g, false, false);
    });
  }

  function firstDraft(el) {
    var found = null;
    el.querySelectorAll('[data-hc-cd-engrave-form]').forEach(function (f) {
      if (!found && isDraft(engraveOf(f))) found = f;
    });
    return found;
  }

  ready(function () {
    var el = root();
    if (!el) return;

    /* Produktovka: odchytit odeslání formuláře. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      addFromForm(form);
    });

    /* Vše uvnitř panelu je delegované — obsah se překresluje. */
    el.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-hc-cd-close]') || t.closest('[data-hc-cd-close-btn]')) { e.preventDefault(); close(); return; }

      var step = t.closest('[data-hc-cd-step]');
      if (step) {
        e.preventDefault();
        if (step.disabled) return;
        var line = step.closest('[data-hc-cd-line]');
        if (!line) return;
        var q = parseInt(line.getAttribute('data-hc-cd-qty'), 10) || 1;
        q += parseInt(step.getAttribute('data-hc-cd-step'), 10);
        queueQty(line.getAttribute('data-hc-cd-key'), Math.max(0, q));
        return;
      }

      var add = t.closest('[data-hc-cd-add]');
      if (add) {
        e.preventDefault();
        var pred = dlSnap();              /* datová vrstva: stav před přidáním */
        busy(true);
        run([], function () { return post('/cart/add.js', withSections({ items: [{ id: String(add.getAttribute('data-hc-cd-add')), quantity: 1 }] })); }, undefined, pred,
          dlAdd({}, String(add.getAttribute('data-hc-cd-add')), 1));
        return;
      }

      /* „Upravit gravírování“: rozbalit uložené, předvyplněné. */
      var edit = t.closest('[data-hc-cd-engrave-edit]');
      if (edit) {
        e.preventDefault();
        var eline = edit.closest('[data-hc-cd-line]');
        var g = engraveOf(eline && eline.querySelector('[data-hc-cd-engrave-form]'));
        if (g) setCollapsed(g, false, true);
        return;
      }

      /* K pokladně s rozepsaným gravírováním: nejdřív uložit (postupně
         každé), jinak by zákazník odešel bez něj. Prázdný text zastaví
         česká hláška, stejně jako na produktovce. */
      var cta = t.closest('.hc-cd__cta');
      if (cta && firstDraft(el)) {
        e.preventDefault();
        var kolo = 0;
        (function dalsi() {
          var f = firstDraft(el);
          if (!f || ++kolo > 10) {
            /* Datová vrstva: begin_checkout až s uloženým gravírováním. */
            if (!f) { dlCall('beginCheckout'); window.location.href = cta.href; }
            return;
          }
          saveEngrave(f).then(function (ok) { if (ok) dalsi(); });
        }());
      } else if (cta) {
        /* Datová vrstva: begin_checkout, odkaz pak pokračuje sám. */
        dlCall('beginCheckout');
      }
    });

    el.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-hc-cd-engrave-form]');
      if (!form) return;
      e.preventDefault();
      saveEngrave(form);
    });

    el.addEventListener('change', function (e) {
      /* Text a písmo v konfigurátoru do košíku nesahají. */
      if (e.target.closest('[data-hc-cd-engrave-form]')) return;

      if (e.target.closest('[data-hc-cd-gift-none]')) { noGift(); return; }
      var pick = e.target.closest('[data-hc-cd-gift-pick]');
      if (pick) { pickGift(pick); return; }

      var input = e.target.closest('[data-hc-cd-addon]');
      if (!input) return;
      var line = input.closest('[data-hc-cd-line]');
      if (!line) return;

      /* Gravírování: rozbalení obstará hobbychef-engrave.js, do košíku
         se sahá jen při odškrtnutí už uloženého. */
      if (input.hasAttribute('data-hc-engrave-toggle')) {
        var g = engraveOf(line.querySelector('[data-hc-cd-engrave-form]'));
        if (!g || input.checked) return;
        if (g.sum) g.sum.hidden = true;
        if (g.saved) removeEngrave(g);
        return;
      }

      togglePouzdro(line, input);
    });

    /* Ikona košíku v hlavičce otevře panel místo skoku na /cart. */
    var cartLink = document.querySelector('.hc-cart');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        busy(true);
        /* Datová vrstva: view_cart po překreslení (ne po přidání — tam se
           panel otevírá sám a hlásí se add_to_cart). */
        sectionHtml(null).then(function (html) { swap(html); dlCall('viewCart'); banner(null); open(); busy(false); });
      });
    }
  });
}());
